import { PoweredBy } from '@repo/ui/atoms';
import { useContext } from 'react';
import { AnalyticsContext, MetadataContext } from '../utils/ContextWrapper';
import { sendEvent } from '../utils/sendEvent';
import { useStudyContext } from '../utils/StudyContext';
import { useTranslationsContext } from '../utils/TranslationsContext';

const PoweredByUxSignals = () => {
    const { study } = useStudyContext();
    const analyticsId = useContext(AnalyticsContext).id;
    const demoMode = useContext(MetadataContext).demoMode;

    const { t } = useTranslationsContext();

    if (demoMode) {
        return null;
    }

    return (
        <PoweredBy
            orgString={t('footer.poweredBy', { company: study.orgName })}
            onClick={() => {
                sendEvent(
                    {
                        analyticsId,
                        studyId: study.id,
                        event: 'embed.poweredby.clicked',
                    },
                    demoMode,
                );
            }}
        />
    );
};

export default PoweredByUxSignals;
